import axios from 'axios';
import { baseUrl } from '@/config';

const PREFIX_URL = '/settings/oper/event-guide-settings';

export default {
  /**
   * 임계치 가이드 자원 설정을 위한 목록을 조회한다.
   * @author yelim
   */
  getSettingEventGuideRscTree(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}/get-setting-event-guide-rsc-by-tree.do`, params);
  },
  /**
   * 임계치 가이드 자원 목록을 불러온다.
   * @author yelim
   * @param  {[type]} params [description]
   */
  getTargetThresGuide(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}/get-target-thres-guide.do`, params);
  },
  /**
   * 임계치 가이드 자원 목록을 수정한다.
   * @author yelim
   * @param  {[type]} params [description]
   */
  updateGuideRscInfo(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}/update-guide-rsc-info.do`, params);
  },
  /**
   * 임계치 가이드 자원을 삭제한다.
   * @author yelim
   * @param  {[type]} params [description]
   */
  deleteThresholdRsc(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}/delete-threshold-rsc.do`, params);
  },
  /**
   * 임계치 가이드 주기설정 정보를 로드한다.
   * @author yelim
   * @return {[type]} [description]
   */
  getBasicinfoSetForGuide() {
    return axios.get(`${baseUrl}${PREFIX_URL}/get-basicinfo-set-for-guide.do`);
  },
  /**
   * 임계치 가이드 주기를 설정한다.
   * @author yelim
   * @return {[type]} [description]
   */
  setBasicinfoSetForGuide(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}/set-basicinfo-set-for-guide.do`, params);
  },
  /**
   * 임계치 가이드 분석 결과를 제공한다.
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getGuideResultList(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}/get-guide-result-list.do`, params);
  },
  /**
   *선택할 자원의 이벤트 판단조건을 조회한다.
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getSettingThresholdInfo(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}/get-setting-threshold-info.do`, params);
  },
  /**
   * 이벤트 임계치 분석 결과를 조회한다.
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  loadThresholdGuideChart(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}/get-threshold-guide-data.do`, params);
  },
  loadThresholdRsltByRsc(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}/get-threshold-guide-data-by-rsc.do`, params);
  },
  setEventThresholdCondition(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}/set-event-threshold-condition.do`, params);
  },
  getThresholdTargetObjInfo(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}/get-threshold-target-obj-info.do`, params);
  },
  getThresholdTargetObjDefine() {
    return axios.get(`${baseUrl}${PREFIX_URL}/get-threshold-target-obj-define.do`);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/common/event-guide-settings.js